var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('TableComponent',{attrs:{"items":_vm.itemsFiltered,"loading":_vm.loading,"group":true},on:{"showDetails":_vm.showDetails,"showGroup":_vm.showGroup}}),_c('router-view',{on:{"update":_vm.update,"showDetails":_vm.showDetails}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }